import { Link } from "../models/Link";
import api from "./api"; // custom axios instance

export const LinkService = {
  async getLinks(matterId: string): Promise<Link[]> {
    const res = await api.get(`/api/v1/links`, {
      params: { matterId },
    });
    return res.data?.data ?? [];
  },

  async getLink(linkId: string): Promise<Link> {
    const res = await api.post(`/api/v1/links/${linkId}`);
    return res.data?.data?._id;
  },

  async createLink(link: Partial<Link>): Promise<string> {
    const res = await api.post("/api/v1/links", link);
    return res.data?.data?._id;
  },

  async updateLink(
    linkId: string,
    linkData: Partial<Omit<Link, "_id">>,
  ): Promise<void> {
    await api.put(`/api/v1/links/${linkId}`, linkData);
  },

  async deleteLink(linkId: string): Promise<void> {
    await api.delete(`/api/v1/links/${linkId}`);
  },
};
